import classNames from "classnames"

import Radio from "@components/elements/V2/Buttons/Radio"
import PriceDisplay from "@components/elements/V2/PriceDisplay"
import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import React, { useId } from "react"

export type Variant = {
  id: string
  label: string
  price: string
  optionIndex: number
  reviewSkus: string[]
}

export type VariantsProps = {
  variants: Variant[]
  selectedVariantOption: number
  onVariantClick: (index: number) => void
}

const Variants = ({
  variants,
  selectedVariantOption,
  onVariantClick,
}: VariantsProps) => {
  const radioGroupName = useId()

  return (
    <div className="space-y-16">
      <Typography
        text="Modify your order"
        font="grotesk"
        color={Color.Charcoal}
        size="body-md"
        weight="medium"
      />
      <div className="space-y-12">
        {variants.map((variant) => {
          const isSelected = variant.optionIndex === selectedVariantOption

          return (
            <div
              key={variant.id}
              onClick={() => onVariantClick(variant.optionIndex)}
              className={classNames(
                "flex cursor-pointer items-start gap-10 rounded-10 border-[1.5px] px-14 py-16 transition-colors duration-200",
                isSelected
                  ? "border-charcoal"
                  : "border-charcoal/20 hover:border-charcoal/50"
              )}
            >
              <Radio
                id={variant.id}
                name={radioGroupName}
                value={String(variant.optionIndex)}
                checked={isSelected}
                onChange={() => onVariantClick(variant.optionIndex)}
                className="pt-[3px]"
              />
              <div className="flex w-full items-start justify-between gap-16">
                <label htmlFor={variant.id}>
                  <Typography
                    text={variant.label}
                    font="grotesk"
                    color={Color.Charcoal}
                    size="body-md"
                    weight="medium"
                    element="span"
                    className="block"
                  />
                </label>
                <PriceDisplay
                  productPrices={{ price: variant.price }}
                  priceFontSize="body-md"
                  priceFontWeight="medium"
                  showDecimals={false}
                  className="flex-shrink-0"
                />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Variants
